export const ImportSessionKey = 'import-session';
export const ImportSessionResourceKey = 'import-session-resource';
export const ImportSessionSummaryKey = 'import-session-summary';